import _extends from "babel-runtime/helpers/extends";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
/**
 * FirstTimeVoiceTypePrompt
 *
 * The prompt for a new user to ask them their voice type.
 *
 * Params:
 *    voiceTypeSelected: PropTypes.func,
 *      Event callback when the user selects the Continus button after choosing a voice type.  A single string
 *      param of male, female, or child is passed.
 *
 *    cancel: PropTypes.func,
 *      Event callback when the user presses the cancel button.
 *
 *    brandName: PropTypes.string
 *      What brandname to put into the instruction text. Zoom sets this to "Rosetta\u00a0Stone" and that's
 *      the default value here.
 *
 */

import React, { PureComponent } from "react";
import Lion from "@rosetta/react-lion";
import styled from "@emotion/styled";
import { buttonTypes, ModalPrompt } from "@rosetta/react-common-ui";
import { PropTypes } from "prop-types";

import VoiceTypeButton from "./VoiceTypeButton";

var VoiceTypeSelectionWrapperDiv = styled.div({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px"
});

var FirstTimeVoiceTypePrompt = function (_PureComponent) {
  _inherits(FirstTimeVoiceTypePrompt, _PureComponent);

  function FirstTimeVoiceTypePrompt() {
    var _temp, _this, _ret;

    _classCallCheck(this, FirstTimeVoiceTypePrompt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      voiceType: null
    }, _this.handleClickVoiceType = function (voiceType) {
      return function () {
        _this.setState(function (state) {
          return _extends({}, state, { voiceType: voiceType });
        });
      };
    }, _this.commitSelection = function () {
      _this.props.voiceTypeSelected(_this.state.voiceType);
    }, _this.render = function () {
      var buttons = [{
        disabled: false,
        buttonType: buttonTypes.default,
        labelKey: _this.props.cancelLabelKey,
        actionFunc: _this.props.cancel
      }, {
        disabled: _this.state.voiceType === null,
        buttonType: buttonTypes.primary,
        labelKey: "continue_button_label",
        actionFunc: _this.commitSelection
      }];

      return React.createElement(
        "div",
        null,
        React.createElement(
          ModalPrompt,
          {
            headerTitleKey: "mic_calibration_voice_type_state",
            cancelAction: _this.cancelAction,
            buttons: buttons,
            hideAllCancelOptions: true
          },
          React.createElement(Lion.span, { lionkey: "preferences_speech_voice_type" }),
          React.createElement(
            VoiceTypeSelectionWrapperDiv,
            null,
            React.createElement(VoiceTypeButton, {
              id: "voice_type_male",
              name: "voice_type",
              value: "male",
              disabled: false,
              labelKey: "mic_calibration_voice_type_male",
              selected: _this.state.voiceType === "male",
              clickVoiceType: _this.handleClickVoiceType("male")
            }),
            React.createElement(VoiceTypeButton, {
              id: "voice_type_female",
              name: "voice_type",
              value: "female",
              disabled: false,
              labelKey: "mic_calibration_voice_type_female",
              selected: _this.state.voiceType === "female",
              clickVoiceType: _this.handleClickVoiceType("female")
            }),
            React.createElement(VoiceTypeButton, {
              id: "voice_type_child",
              name: "voice_type",
              value: "child",
              disabled: false,
              labelKey: "mic_calibration_voice_type_child",
              selected: _this.state.voiceType === "child",
              clickVoiceType: _this.handleClickVoiceType("child")
            })
          ),
          React.createElement(Lion.span, { lionkey: "local_login_gender_subtext", replacements: { $brandName: _this.props.brandName } })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return FirstTimeVoiceTypePrompt;
}(PureComponent);

FirstTimeVoiceTypePrompt.propTypes = {
  voiceTypeSelected: PropTypes.func,
  cancel: PropTypes.func,
  brandName: PropTypes.string
};
FirstTimeVoiceTypePrompt.defaultProps = {
  brandName: "Rosetta\xA0Stone",
  cancelLabelKey: "misc_cancel"
};


export default FirstTimeVoiceTypePrompt;